import React, { useCallback, useState } from "react";
import styled from "styled-components";
import { appropriateKeyPressed } from "../../../functional/helpers";
import { CarouselViewportProvider, useCarouselContext } from "../context";
var NavDirection;
(function (NavDirection) {
    NavDirection["Left"] = "left";
    NavDirection["Right"] = "right";
    NavDirection["Up"] = "up";
    NavDirection["Down"] = "down";
})(NavDirection || (NavDirection = {}));
const _CarouselViewport = ({ children, className }) => {
    const { state, setViewportRef, dispatch } = useCarouselContext("CarouselViewport");
    const [hasFocus, setHasFocus] = useState(false);
    const { direction, activeSlideIndex, nSlides, carouselId } = state;
    const getDirectionCondition = useCallback((locale, navDirection) => {
        const isLeft = navDirection === (locale === "ltr" ? NavDirection.Left : NavDirection.Right);
        const isRight = navDirection === (locale === "ltr" ? NavDirection.Right : NavDirection.Left);
        return isLeft ? activeSlideIndex > 0 : isRight ? activeSlideIndex < nSlides - 1 : false;
    }, [activeSlideIndex, nSlides]);
    const handleKeyUp = useCallback((e) => {
        if (appropriateKeyPressed(e.key, "ArrowLeft", "Left") && getDirectionCondition(direction, NavDirection.Left)) {
            direction === "ltr" ? dispatch({ type: "goToPrevious" }) : dispatch({ type: "goToNext" });
        }
        if (appropriateKeyPressed(e.key, "ArrowRight", "Right") && getDirectionCondition(direction, NavDirection.Right)) {
            direction === "ltr" ? dispatch({ type: "goToNext" }) : dispatch({ type: "goToPrevious" });
        }
    }, [dispatch, direction, getDirectionCondition]);
    const handleFocus = useCallback(() => {
        setHasFocus(true);
    }, []);
    const handleBlur = useCallback(() => {
        setHasFocus(false);
    }, []);
    const handleMouseDown = (e) => {
        e.preventDefault();
        setHasFocus(false);
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    };
    return (React.createElement("div", { "data-testid": "viewport", className: className, tabIndex: 0, ref: setViewportRef, onKeyUp: handleKeyUp, onFocus: handleFocus, onMouseDown: handleMouseDown, onBlur: handleBlur, dir: state.direction, "aria-activedescendant": `${carouselId}-slide-${activeSlideIndex}`, role: "group" },
        React.createElement(CarouselViewportProvider, { value: { hasFocus } }, children)));
};
export const CarouselViewport = styled(_CarouselViewport) `
  overflow: hidden;
  cursor: auto;
  width: 100%;
  height: 100%;
`;
//# sourceMappingURL=CarouselViewport.js.map